import apiClient from 'apiClient';
import withCaseErrorMiddleware from '../caseError/withCaseErrorMiddleware';
import { PatchPropertyOccupantResponseData, PatchPropertyResponseData } from '../types';

import {
  DeletePropertyOccupantResponse,
  PatchPropertyOccupantResponse,
  PatchPropertyResponse,
  PostPropertyOccupantResponse,
} from './types';

const PREFIX = '/api/v1/cases';

export const patchProperty = (caseId: string, field: string, value: any): PatchPropertyResponse => {
  return apiClient
    .patch<PatchPropertyResponseData>(`${PREFIX}/${caseId}/property`, { [field]: value })
    .then(withCaseErrorMiddleware);
};

export const postPropertyOccupant = (caseId: string): PostPropertyOccupantResponse => {
  return apiClient.post(`${PREFIX}/${caseId}/property/occupant`);
};

export const patchPropertyOccupant = (
  caseId: string,
  occupantId: number,
  field: string,
  value: any,
): PatchPropertyOccupantResponse => {
  return apiClient
    .patch<PatchPropertyOccupantResponseData>(`${PREFIX}/${caseId}/property/occupant/${occupantId}`, { [field]: value })
    .then(withCaseErrorMiddleware);
};

export const deletePropertyOccupant = (caseId: string, occupantId: number): DeletePropertyOccupantResponse => {
  return apiClient.delete(`${PREFIX}/${caseId}/property/occupant/${occupantId}`);
};
